var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-4 pb-4"},[_c('b-container',{staticClass:"stats_part p-3 mb-3 mt-2 rounded bg-white"},[_c('div',{staticClass:"page-header"},[_c('h2',[_c('b-icon',{attrs:{"icon":"chat-left-dots"}}),_vm._v(" "+_vm._s(_vm.$t("title"))+" ")],1)]),_c('comply-or-explain-guideline-text')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }